import ErrorPage from "components/ErrorPage"
import React from "react"

export const safeLazyImport = (module: () => Promise<any>) => {
  return React.lazy(() => {
    return module().catch(e => {
      if (e?.message?.includes("Failed to fetch dynamically imported module")) {
        console.log("Chunk not found. Reloading.")
        window.location.reload()
        return {
          default: () => (
            <div className="flex justify-center p-5">
              Fetching latest updates…
            </div>
          ),
        }
      }

      console.error(e)
      return {
        default: () => (
          <ErrorPage
            errorStatus={404}
            title="Failed to load"
            description="This page couldn't be loaded. Please refresh to try again."
          />
        ),
      }
    })
  })
}
